import { BaseModel } from "./base";
import SituacaoVeiculo from "./situacaoVeiculo";

export class TipoVeiculo extends BaseModel {
  constructor(
    public id: number,
    public ativo: boolean,
    public descricao: string,
    public createdAt: Date,
    public updatedAt: Date,
    public deletedAt: Date,
    public situacaoVeiculo: SituacaoVeiculo
  ) {
    super(id);
  }
}
